import React from "react";
// import { StaticImage } from "gatsby-plugin-image";
import * as classes from "./ImageSlider.module.scss";
import ImageNakedView from "../../assets/images/slider/House-Naked-View-04.webp";
// import ImageSustainibilityView from "../../assets/images/slider/house_plastic_new.webp";
import ImageSustainibilityView from "../../assets/images/slider/forguidancetext.png";
import Container from "../UI/Container/Container";
// import ReactCompareImage from "react-compare-image";
import ImageCompare from "./ReactImageCompareModified";
const ImageSlider = () => {
  return (
    <Container>
      <div className={classes.ImageSlider__Container}>
        {/* <h2>Plastic waste hotspots in the house</h2> */}
        <br
          style={{
            margin: 0,
            padding: 0,
            content: `""`,
            height: "0px",
            display: "block",
          }}
        ></br>
        <ImageCompare
          className={"test"}
          leftImage={ImageNakedView}
          rightImage={ImageSustainibilityView}
          // leftImageLabel="Naked View"
          rightImageLabel="Sustainability View"
        ></ImageCompare>
      </div>
    </Container>
  );
};

export default ImageSlider;
